import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(_component_LoginForm, {
        title: _ctx.content.title,
        "redirect-link": _ctx.content.redirectAfterLoginUrl,
        class: "mx-auto max-w-400"
      }, null, 8, ["title", "redirect-link"])
    ]),
    _: 1
  }))
}